export const DevelopmentServicesContent = {
    DevelopmentServicesWebPageHeading: "Our Expansive Range of End-to-end Web App Development Services",
    DevelopmentServicesWebPageDescription: "Our web application solutions cover everything from custom cloud platforms & interactive portals to seamless front-end & robust back-end development. We deliver secure, scalable solutions designed to evolve with your business, including expert consulting & ongoing support."
}

export const DevelopmentServicesData = [
    {
        id: "Tab1",
        label: "Web Portal Development",
        content:
            "Enhance your business with our custom web portal development services. We build scalable, secure, & interactive portals that optimize workflows, improve collaboration, & streamline operations. Our solutions ensure seamless access to data, automation, & user engagement across industries.",
        secondContent: "From enterprise portals to self-service platforms, our team delivers feature-rich, high-performance web portals tailored to your needs. Leverage cutting-edge technologies to boost efficiency & create a centralized digital experience for your users.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab3",
        label: "SaaS App Development Services",
        content:
            "With our cutting-edge SaaS app development services, we design & build scalable, secure, & user-friendly SaaS applications that cater to your specific business needs. From multi-tenant architecture to seamless updates, our SaaS app development ensures your solution stands out in the competitive market.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab4",
        label: "Frontend Web App Development",
        content:
            "Deliver stunning, high-performing web applications with our expert frontend development services. We create intuitive, user-friendly interfaces using modern frameworks like React, Angular, & Vue.js, ensuring seamless cross-device experiences.",
        secondContent: "Our team specializes in fast-loading, interactive, & scalable frontend solutions that enhance user engagement & performance. Whether building a progressive web app (PWA) or a complex web platform, we craft solutions that prioritize speed, security, & responsiveness.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab9",
        label: "Backend Web App Development",
        content:
            "Power your web applications with a robust, scalable, & high-performance backend. Our developers specialize in Node.js, Python, PostgreSQL, & cloud technologies, ensuring efficient data handling, real-time processing, & seamless integrations.",
        secondContent: "With a focus on security, reliability, & API-driven architecture, we create optimized backends that support dynamic web applications. Whether handling high-traffic loads or complex business logic, we build future-ready solutions to enhance your platform’s performance.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab5",
        label: "Web Application Consulting",
        content:
            "Navigate the complexities of web development with our expert consulting services. We help businesses select the right technology stack, architecture, & security protocols to ensure long-term success & scalability.",
        secondContent: "Our consultants specialize in performance optimization, cloud migration, & digital transformation strategies. Whether you're launching a new web app or refining an existing one, we provide data-driven insights & technical expertise to accelerate growth.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab6",
        label: "Custom Web Apps Development for Enterprises",
        content:
            "Transform your enterprise with custom web applications designed for efficiency, security, & scalability. We build tailor-made digital solutions that integrate seamlessly with existing workflows, cloud environments, & business operations.",
        secondContent: "Our expert team focuses on automation, real-time data processing, & AI-powered insights to enhance productivity. From custom CRMs to advanced ERP systems, we create enterprise-grade applications that drive innovation & competitive advantage.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab7",
        label: "Headless WordPress Web App Development",
        content:
            "Unlock unparalleled performance & flexibility with headless WordPress web app development. We integrate WordPress’s powerful CMS with modern frontend frameworks like React & Next.js, ensuring a lightning-fast, API-driven experience",
        secondContent: "By separating the backend from the frontend, we deliver highly customized, scalable, & secure web applications. Whether you need a content-rich platform, an eCommerce store, or a marketing website, our solutions ensure enhanced performance & seamless third-party integrations.",
        btnText: "Let's Discuss",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
];